import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import HeaderThin from 'app/components/layout/HeaderThin';
import SectionGroup from 'app/components/general/SectionGroup';
import SchemaForm from 'app/components/general/SchemaForm';

import * as subscriptionPaymentActions from 'app/ducks/subscriptionPayments/actions';
import * as loadingSelectors from 'app/ducks/loading/selectors';
// import * as organisationSelectors from 'app/ducks/organisations/selectors';
import * as subscriptionPaymentSelectors from 'app/ducks/subscriptionPayments/selectors';
import { IMatchPayment } from 'app/ducks/matchPayments/types';

const formSchema = {
  type: 'object',
  required: [],
  properties: {
    // name: {
    //   type: 'string',
    //   title: 'Name',
    // },
    // friendlyCode: {
    //   type: 'string',
    //   title: 'Code (short competition code/acronym)',
    //   minLength: 2,
    // },
  },
};

const uiSchema = {
};

interface ITransferPaymentProps {
  appReady: boolean;
  actions: any;
  match: any;
  afterSubmit: Function;
  subscriptionPayments: any;
  matchPayment: IMatchPayment;
  errors: any;
}

interface ITransferPaymentState {
  originalFormData: any;
  formData: any;
  changed: boolean;
  saved: boolean;
  errors: any;
}

const selector = (state): any => ({
  appReady: loadingSelectors.appReady(state),
  subscriptionPayments: subscriptionPaymentSelectors.getSubscriptionPayments(state),
  errors: {
    ...state.subscriptionPayments.backendErrors,
  },
});

const actionCreators = _.merge(subscriptionPaymentActions);

@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class TransferPayment extends React.Component<
ITransferPaymentProps,
ITransferPaymentState
> {
  static defaultProps: ITransferPaymentProps = {
    appReady: false,
    actions: undefined,
    match: undefined,
    matchPayment: undefined,
    subscriptionPayments: undefined,
    afterSubmit: undefined,
    errors: undefined,
  };

  state: ITransferPaymentState = {
    originalFormData: {},
    formData: {
      nothing: true,
    },
    changed: true,
    saved: false,
    errors: {},
  };

  static getDerivedStateFromProps(nextProps, prevState): any {
    if (!prevState.changed) {
      return {
        ...prevState,
        errors: nextProps.errors,
      };
    }
    return null;
  }

  isValid = (): boolean => !_.isEmpty(this.props.matchPayment?.subscriptionPayment?.id) && _.isEmpty(this.state.errors) && this.state.changed;

  handleChange = (e): void => {
    const changed = true;
    this.setState(() => ({
      formData: e.formData,
      errors: [],
      changed,
    }));
  };

  handleError = (errors): void => {
    this.setState({ errors });
  }

  handleSubmit = (e): void => {
    if (this.isValid()) {
      const payload = {
        id: this.props.matchPayment?.subscriptionPayment?.id,
        transferStatus: 'transfer-required',
      };

      this.props.actions.updateSubscriptionPayment(payload, undefined, undefined, this.props.afterSubmit);
    }
    this.setState({ changed: true });
  };

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            <div className="form-description">
              This will transfer this match payment to the next available match. If there is no available next match, it will be
              {' '}
              <span className="text-weight-medium-bold">'Transfer Pending'</span>
              .
              {' '}
              It will transfer once the next match is availiable.
            </div>
          </div>
        </div>
        <div className="row margin-top">
          <div className="col">
            <SchemaForm
              uiSchema={uiSchema}
              schema={formSchema}
              handleChange={this.handleChange}
              handleError={this.handleError}
              handleSubmit={this.handleSubmit}
              formData={this.state.formData}
              errors={this.props.errors}
              liveValidate={this.state.changed}
              isValid={this.isValid()}
              isLoading={this.props.subscriptionPayments.isSaving}
              hasSaved={this.props.subscriptionPayments.hasSaved}
              hasFailed={this.props.subscriptionPayments.hasFailed}
              originalFormData={this.state.originalFormData}
              buttonText="Transfer Payment"
            />
          </div>
        </div>
      </div>
    );
  }
}
